import { type App, defineAsyncComponent } from 'vue'

import HStack from './layout/HStack.vue'
import VStack from './layout/VStack.vue'
import XStack from './layout/XStack.vue'
import Spacer from './layout/Spacer.vue'
import CoreImage from './CoreImage.vue'
import Tooltip from './Tooltip.vue'
import CoreIcon from './icons/CoreIcon.vue'
import CoreButton from './buttons/CoreButton.vue'
import ComboButton from './buttons/ComboButton.vue'
import MenuListButton from './buttons/MenuListButton.vue'
import Illo from './illustrations/Illo.vue'
import Link from './Link.vue'
import Modal from './modal'

// typography
import BigTitle from './typography/BigTitle.vue'
import Label from './typography/Label.vue'
import BodyText from './typography/BodyText.vue'
import HintText from './typography/HintText.vue'

const AnimatedSprite = defineAsyncComponent(
  () => import('./AnimatedSprite/AnimatedSprite.vue'),
)
const EditableText = defineAsyncComponent(() => import('./EditableText.vue'))
const RadioButton = defineAsyncComponent(
  () => import('./inputs/RadioButton.vue'),
)
const Checkbox = defineAsyncComponent(() => import('./inputs/Checkbox.vue'))
const Checklist = defineAsyncComponent(() => import('./inputs/Checklist.vue'))
const Collapse = defineAsyncComponent(() => import('./Collapse.vue'))
const CoreSelect = defineAsyncComponent(() => import('./inputs/CoreSelect.vue'))
const CoreSelectOption = defineAsyncComponent(
  () => import('./inputs/CoreSelectOption.vue'),
)
const RangeInput = defineAsyncComponent(() => import('./inputs/RangeInput.vue'))
const EdgeObserver = defineAsyncComponent(() => import('./EdgeObserver.vue'))
const Menu = defineAsyncComponent(() => import('./menu/Menu.vue'))
const MenuList = defineAsyncComponent(() => import('./menu/MenuList.vue'))
const MenuButton = defineAsyncComponent(
  () => import('./buttons/MenuButton.vue'),
)
const SearchInput = defineAsyncComponent(
  () => import('./inputs/SearchInput.vue'),
)
const PriceInput = defineAsyncComponent(() => import('./inputs/PriceInput.vue'))

export default {
  install(app: App) {
    // installing core sources
    app.component('HStack', HStack)
    app.component('VStack', VStack)
    app.component('XStack', XStack)
    // eslint-disable-next-line vue/no-reserved-component-names
    app.component('Spacer', Spacer)
    app.component('Tooltip', Tooltip)
    app.component('CoreImage', CoreImage)
    app.component('CoreIcon', CoreIcon)
    app.component('CoreButton', CoreButton)
    app.component('ComboButton', ComboButton)
    app.component('MenuListButton', MenuListButton)
    app.component('Illo', Illo)
    // eslint-disable-next-line vue/no-reserved-component-names
    app.component('Link', Link)
    // dynamic ones
    app.component('AnimatedSprite', AnimatedSprite)
    app.component('EditableText', EditableText)
    app.component('RadioButton', RadioButton)
    app.component('Checkbox', Checkbox)
    app.component('Checklist', Checklist)
    app.component('Collapse', Collapse)
    app.component('CoreSelect', CoreSelect)
    app.component('CoreSelectOption', CoreSelectOption)
    app.component('EdgeObserver', EdgeObserver)
    // eslint-disable-next-line vue/no-reserved-component-names
    app.component('Menu', Menu)
    app.component('MenuList', MenuList)
    app.component('MenuButton', MenuButton)
    app.component('Modal', Modal)
    app.component('RangeInput', RangeInput)
    app.component('SearchInput', SearchInput)
    app.component('PriceInput', PriceInput)
    // typography
    app.component('BigTitle', BigTitle)
    // eslint-disable-next-line vue/no-reserved-component-names
    app.component('Label', Label)
    app.component('BodyText', BodyText)
    app.component('HintText', HintText)
  },
}
